/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Table_Column_ReplyInputs */



/**
* | output |
* | --- |
* | "Reply" |
*
* @param {Editor_Table_Column_ReplyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_table_column_reply = /** @type {((inputs?: Editor_Table_Column_ReplyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Table_Column_ReplyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Reponse")
	if (locale === "de") return /** @type {LocalizedString} */ ("Antwort")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rispondere")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отвечать")
	if (locale === "es") return /** @type {LocalizedString} */ ("Respuesta")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("回复")
	if (locale === "ja") return /** @type {LocalizedString} */ ("返事")
	if (locale === "hi") return /** @type {LocalizedString} */ ("जवाब")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Responder")
	return /** @type {LocalizedString} */ ("Reply")
});